import { apiConfig } from "./config";

export const shippingApi = {
  list: async (from: any, to: any) => {
    const response = await apiConfig.get(
      `/api/front/chef/chef-report/${from}/${to}`
    );
    return response;
  },
};
